import React from "react";
import useHeaderDataStatus from "../../../../components/hooks/useHeaderDataStatus";
import { MdOutlineCheck } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import WrapperLoader from "../../../../components/spinner/WrapperLoader";

function FinalData({ scriptPresentData, scriptPresentDataIsLoading }) {
  const isFinalDataFound =
    scriptPresentData?.files?.["final_data_qc.py"]?.file_name;
  return (
    <div
      title={!isFinalDataFound && "Script is missing"}
      className={
        scriptPresentDataIsLoading
          ? "text-gray-400"
          : !isFinalDataFound && "text-red-400"
      }
    >
      Final Data QC
      <WrapperLoader isLoading={scriptPresentDataIsLoading}></WrapperLoader>
      {/* <div className="flex justify-center">
        <WrapperLoader isLoading={scriptPresentDataIsLoading}>
          {isFinalDataFound ? (
            <MdOutlineCheck color="green" size={16} />
          ) : (
            <IoCloseOutline color="red" size={16} />
          )}
        </WrapperLoader>
      </div> */}
    </div>
  );
}

export default FinalData;
